<template>
  <div class="sidebar-container responsive-height">
    <v-list class="overflow-y-auto">

      <!-- ===== PARENT MENU ===== -->
      <v-list-group v-for="item in items" :key="item.title" v-model="item.active" :prepend-icon="item.action">
        <!-- ⭐ Parent activator -->
        <template v-slot:activator>
          <v-list-item class="menu-row">

            <router-link :to="item.link" class="text-decoration-none text--ash menu-text">
              {{ item.title }}
            </router-link>

            <!-- VIDEO ICON (Parent) -->
            <v-icon v-if="hasTutorial(item.link)" small color="red"
              @click.stop="openVideo(getTutorialByRoute(item.link).info_link)">
              mdi-play-circle
            </v-icon>

          </v-list-item>
        </template>

        <!-- ===== CHILD MENU ===== -->
        <v-list-item v-for="child in item.items" :key="child.title" link>
          <v-list-item class="menu-row">

            <router-link :to="child.childLink" class="text-decoration-none text--ash">
              {{ child.title }}
            </router-link>

            <!-- VIDEO ICON (Child) -->
            <v-icon v-if="hasTutorial(child.childLink)" small color="red"
              @click.stop="openVideo(getTutorialByRoute(child.childLink).info_link)">
              mdi-play-circle
            </v-icon>

          </v-list-item>
        </v-list-item>

      </v-list-group>

    </v-list>

    <!-- ⭐ VIDEO MODAL (Always outside list) -->
    <v-dialog v-model="videoModal" max-width="800">
      <v-card>
        <v-card-title>
          Tutorial Video
          <v-spacer></v-spacer>
          <v-btn icon @click="videoModal = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <iframe v-if="videoUrl" :src="videoUrl" width="100%" height="400" frameborder="0" allowfullscreen></iframe>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  data() {

    return {
      videoModal: false,
      videoUrl: "",
      items: [
        {
          action: "mdi-view-dashboard",
          title: "Dashboard",
          link: "/dashboard?",
          active: false,
        },
        {
          action: "mdi-finance",
          title: "Web Trade",
          link: "/web-trade",
          active: false,
        },
        {
          action: "mdi-wallet-travel",
          title: "Wallet",
          link: "#",
          active: false,
          items: [
            { title: "Transactions", childLink: "/wallet" },
            { title: "Wallet Information", childLink: "/bank-information?tab=1" },
          ],
        },
        {
          action: "mdi-finance",
          title: "MAM Wallet",
          link: "/mam-wallet",
          active: false,
        },
        {
          action: "mdi-account-tie-outline",
          title: "Manager",
          link: "#",
          active: false,
          items: [
            { title: "My Manager Accounts", childLink: "/mt5-accounts?tab=4" },
            { title: "Create Manager Account", childLink: "/create-manager-account" },
          ],
        },
        {
          action: "mdi-account-outline",
          title: "Profile",
          link: "#",
          active: false,
          items: [
            { title: "Profile & Verification", childLink: "/profile-verify" },
            { title: "Change Profile Password", childLink: "/change-password" },
            { title: "Change Leverage", childLink: "/change-leverage" },
            { title: "Change MT5 Password", childLink: "/change-mt5-password" },
          ],
        },
        {
          action: "mdi-signal",
          title: "MT5 Accounts",
          link: "/mt5-accounts?tab=1",
          active: false,
        },
        {
          action: "mdi-trending-up",
          title: "Tradings",
          link: "/trading-details?tab=1",
          active: false,
        },
        {
          action: "mdi-currency-usd",
          title: "Invest",
          link: "#",
          active: false,
          items: [
            { title: "My Investor Accounts", childLink: "/mt5-accounts?tab=3" },
            { title: "Open Investor Account", childLink: "/create-investor-account?type=general" },
          ],
        },
        {
          action: "mdi-chat-outline",
          title: "News",
          link: "/news",
          active: false,
        },
        {
          action: "mdi-chat-outline",
          title: "Support",
          link: "/support?",
          active: false,
        },
        {
          action: "mdi-help-circle-outline",
          title: "FAQ",
          link: "/faq?",
          active: false,
        },
        {
          action: "mdi-file-document-outline",
          title: "Terms & Conditions",
          link: "/terms-and-condition",
          active: false,
        },
        {
          action: "mdi-chart-timeline-variant",
          title: "Platforms",
          link: "/platform?",
          active: false,
        },
      ],
    };
  },

  mounted() {
    this.setActiveMenu();
  },

  watch: {
    "$route.path": "setActiveMenu",
  },
  computed: {
    ...mapState("profile", ["client", "tutorials"])
  },
  methods: {
    setActiveMenu() {
      const currentPath = this.$route.path;
      this.items.forEach((item) => {
        if (item.items) {
          item.active = item.items.some((child) => child.childLink === currentPath);
        } else {
          item.active = item.link === currentPath;
        }
      });
    },

    // ⭐ tutorial match checker
    getTutorialByRoute(link) {
      if (!this.tutorials) return null;

      // /dashboard -> dashboard বানাচ্ছি
      const routeName = link.replace("/", "").split("?")[0];

      // tutorials.route = client=dashboard
      return this.tutorials.find(t =>
        t.route === `client=${routeName}`
      );
    },

    openVideo(url) {
      this.videoUrl = this.convertYoutubeEmbed(url);
      this.videoModal = true;
    },

    // youtube embed convert
    convertYoutubeEmbed(url) {
      if (url.includes("youtu.be/")) {
        const id = url.split("youtu.be/")[1];
        return `https://www.youtube.com/embed/${id}`;
      }
      if (url.includes("watch?v=")) {
        const id = url.split("watch?v=")[1];
        return `https://www.youtube.com/embed/${id}`;
      }
      return url;
    },
    hasTutorial(link) {
      if (this.client?.is_tutorial != 1) return false;
      const tutorial = this.getTutorialByRoute(link);
      if (!tutorial) return false;
      if (!tutorial.info_link) return false;
      return true;
    }
  },

};
</script>

<style scoped>
.v-list-item__content_main {
  width: 600px !important;
}

.listgroup {
  display: flex;
  justify-content: space-between;
}

.menu-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.menu-text {
  text-decoration: none;
  color: inherit;
  font-size: 14px;
}

.video-icon {
  color: #ff3b3b;
  font-size: 18px;
  margin-left: 10px;
}
</style>